/**
 * KanbanAnnouncer — visually-hidden aria-live region for the kanban board.
 *
 * Consumes a single string. When the string changes, screen readers announce
 * it. Used to narrate drag pickup / move / drop / cancel events from dnd-kit's
 * accessibility.announcements hooks.
 */
export function KanbanAnnouncer({ message }: { message: string }) {
  return (
    <div
      role="status"
      aria-live="assertive"
      aria-atomic="true"
      style={{
        position: "absolute",
        width: 1,
        height: 1,
        margin: -1,
        padding: 0,
        overflow: "hidden",
        clip: "rect(0 0 0 0)",
        whiteSpace: "nowrap",
        border: 0,
      }}
    >
      {message}
    </div>
  );
}
